<template>
  <div class="maincon">
    <div class="bmap-page-container">

      <el-bmap vid="bmapDemo" :bmap-manager="bmapManager" :zoom="zoom" :center="center" :events="events"
        class="bmap-demo">

        <weixing-plugin :map="map"></weixing-plugin>
        <el-bmap-polygon :v-if="polygons.length" v-for="(polygon, index) in polygons" :visible="visible" :key="index"
          :vid="index" :ref="`polygon_${index}`" :path="polygon.path" :enable-editing="polygon.enableEditing"
          :events="polygon.events"></el-bmap-polygon>


        <el-bmap-label v-for="item in pointsList" :position="[item.lng_lat.lng, item.lng_lat.lat]"
          :visible="item.visible"
          :offset="[-23,-50]"
           :is-custom="true">
          <div class="labelbox" style="color:#fff;font-size:20px;">

            <div class="labelcontent">
              <img class="iconimg" :src="item.imgurl" />
              <div class="labeltext">
                {{ item.name || '空' }}
              </div>
            </div>
            <span class="labeldown" style="color:#000"></span>
          </div>
        </el-bmap-label>


      </el-bmap>
    </div>

  </div>
</template>

<script>

import weixingPlugin from '@/components/bmap/weixingPlugin.vue'
import VueBMap from "vue-bmap-gl";
import { lazyBMapApiLoaderInstance } from 'vue-bmap-gl';

import { pointData, blockDetail } from '@/api/cityresearch'

let bmapManager = new VueBMap.BMapManager();


const icontype1 = '@/assets/icon/wenwu.png'
const icontype2 = '@/assets/icon/gaoya.png'


export default {
  
  components: { weixingPlugin },

  props: {
    cate: {
      type: Number,
      default: 1
    },//商业 2产业
    polygondata: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    block: {
      get() {
        return this.$store.state.block
      },
      set(v) {
        this.$store.dispatch('changeBlock', v)
      }
    }
  },

  watch: {
    // block: {
    //   handler(v) {
    //     this.getCenterPoint()
    //     this.getPointData()
    //   }
    // },

    polygondata: {
      handler(v) {
        this.getCenterPoint()
        this.getPointData()
        // console.log('==data==', v)
        // this.handlerData(v)
        if (v.length === 0) {
          this.polygons = []
          this.map.removeOverlay(this.blockoverlay) 
        } else {
          v.map(item => {
            this.handlerData(item.set)
          })
        }

      },
      deep: true
    }
  },

  mounted() {
    this.getCenterPoint()
    this.getPointData()
    this.polygondata.map(item => {
      this.handlerData(item.set)
    })

  },
  data() {
    return {
      area: '',
      pointsList: [
        {
          id: 1,
          name: '这是标题1',
          lng_lat: {
            lat: '1',
            lng: '1'
          },
          imgurl: ''
        }
      ],
      visible: true,
      polygons: [],
      map: {},
      bmapManager,
      geodata: "",
      events: {
        init: (o) => {
          this.map = o

        },
      },
      count: 1,
      center: [0, 0],
      zoom: 12
    };
  },
  methods: {

    //获取地图的中心点
    getCenterPoint() {
      blockDetail({ city_plate_id: this.block }).then(res => {
        this.center = [res.data.lng, res.data.lat]
        this.zoom = 15;
      })
    },

    handleImg(data) {
      const res = data.map(item => {
        item.imgurl = require('@/assets/icon/icontype' + item.type + '.png')
        return item
      })
      return res
    },

    //获取点数据
    getPointData() {
      const params = {
        city_plate_id: this.block,
        type: this.cate
      }
      if (this.block) {
        pointData(params).then(res => {
          this.pointsList = this.handleImg(res.data)

        })
      }


    },

    // 处理数据
    handlerData(data) {
      const dataArr = JSON.parse(data) // 获取地图数据数组
      dataArr.map(obj => {
        this.drawPloygonByBD(obj)
      })
    },

    // 获取手动画 数据库api数据 画多变形
    drawPloygonByBD(obj) {
      // this.map.clearOverlays(); //清除地图覆盖物
      this.map.removeOverlay(this.blockoverlay)

      var ply = new BMapGL.Polygon(obj.multipoint, {
        strokeWeight: 2,
        strokeColor: '#000000',
        strokeStyle: 'dashed',
        fillColor: '#dedede',

        // fillOpacity: 0,
      }) // 建立多边形覆盖物
      this.blockoverlay = ply
      this.map.addOverlay(ply) // 添加覆盖物
      this.map.setViewport(ply.getPath()) // 调整视野
    },


  }


};
</script> 
<style lang="scss" scoped>
.maincon {
  position: relative;
  height: calc(100vh - 180px);
}

.contrl {
  position: absolute;
  
  right: 0;
  top: 0;
  width: 200px;
  background: #fff;
  height: calc(100vh - 180px);
  z-index: 9999
}

.bmap-demo {
  height: calc(100vh - 180px);
}

.labelbox {

 
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  align-items: flex-start;

  border-radius: 5px;

  .labelcontent {
    box-shadow: 0px 5px 26px 0px rgba(0, 0, 0, 0.2);
    border: solid 1px #fff;
    background: #fff;
    border-radius: 4px;
    color: #333;
    font-size: 14px;
    padding: 4px;
    display: flex;
    flex-direction: row;
    padding: 5px 10px;
    justify-content: space-between;
    align-items: center;

    .iconimg {
      height: 30px;
      width: 30px;
    }

    .labeltext {
      margin-left: 10px;
    }

    // mar
  }

  .labeldown {
    margin-left:15px;
    width: 0;
    height: 0;
    border-top: 10px solid #fff;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;

  }
}
</style>